import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

export function useKeyboardShortcuts() {
  const navigate = useNavigate()
  const [isSearchOpen, setIsSearchOpen] = useState(false)

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      // Ctrl/Cmd + K for global search
      if ((e.ctrlKey || e.metaKey) && e.key === 'k') {
        e.preventDefault()
        setIsSearchOpen(true)
      }

      // Ctrl/Cmd + H for home/dashboard
      if ((e.ctrlKey || e.metaKey) && e.key === 'h') {
        e.preventDefault()
        navigate('/dashboard')
      }

      // Ctrl/Cmd + B for Bills of Lading
      if ((e.ctrlKey || e.metaKey) && e.key === 'b') {
        e.preventDefault()
        navigate('/dashboard/bl')
      }

      // ESC to close modals/dialogs (handled by Dialog component)
      if (e.key === 'Escape') {
        // Dialog component handles this automatically
      }
    }

    window.addEventListener('keydown', handleKeyDown)
    return () => window.removeEventListener('keydown', handleKeyDown)
  }, [navigate])

  return { isSearchOpen, setIsSearchOpen }
}
